import z from "zod";

export const deleteNotificationSchema = z.object({
  id: z.string(),
});

export const acceptInvitationSchema = z.object({
  id: z.string(),
});

export const declineInvitationSchema = z.object({
  id: z.string(),
});

export const markNotificationAsReadSchema = z.object({
  id: z.string(),
});

export type DeleteNotificationSchema = z.infer<typeof deleteNotificationSchema>;
export type AcceptInvitationSchema = z.infer<typeof acceptInvitationSchema>;
export type DeclineInvitationSchema = z.infer<typeof declineInvitationSchema>;
export type MarkNotificationAsReadSchema = z.infer<typeof markNotificationAsReadSchema>;
